import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-confirm-dialog',
    styleUrls: ['./modal-confirm-dialog.component.scss'],
    templateUrl: './modal-confirm-dialog.component.html',
})
export class ModalConfirmDialogComponent {
    public title: string;
    public firstMessage: string;
    public msgList: string[];

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cancelar';

    constructor(public dialogRef: MatDialogRef<ModalConfirmDialogComponent>) {}

    public set okButtonText(value: string)  {
      this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
      this.cancelButtonTextLabel = value;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-confirm-dialog.component.ts